<template>
  <div>
    <MathLevelList v-if="isNaN(currentLevelId)" @changeLevel="selectLevel" />
    <MathLevelPlay v-else :level="currentLevel" :is-mathsframe="isMathsframe" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { SfMathsLevel } from "@/types/mathsTypes";

import MathLevelList from "@/components/math-levels/MathLevelList.vue";
import MathLevelPlay from "@/components/math-levels/MathLevelPlay.vue";
import apiCall from "@/func/net/apiCall";
// import UserArea from "@/components/permission/UserArea.vue";

export default defineComponent({
  components: { MathLevelList, MathLevelPlay },
  props: { isMathsframe: { type: Boolean, default: false } },
  data() {
    return {
      currentLevel: null as SfMathsLevel | null,
    };
  },
  computed: {
    currentLevelId(): number {
      return parseInt(this.$route.params.levelId as string);
    },
  },
  mounted() {
    if (this.currentLevelId > 0) {
      this.loadLevel(this.currentLevelId);
    }
    // document.body.className = "maths";
  },
  beforeUnmount() {
    // document.body.className = "";
  },
  methods: {
    selectLevel(level: SfMathsLevel) {
      this.currentLevel = level;
    },
    async loadLevel(levelId: number) {
      const resData = await apiCall("math-level/" + levelId);
      if (resData.success) {
        this.currentLevel = resData.data as SfMathsLevel;
      }
    },
  },
});
</script>
